export const BILLING_TYPE = {
  FRANCHISEE: 1,
  CONTRACTOR: 2,
};
